/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { Modal, Button } from 'react-bootstrap'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Spinner from 'react-bootstrap/Spinner'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import Select from 'react-select'

interface ProductCreateProps {
	show: boolean;
	handleClose: (isReload: boolean) => void;
	id: number;
}

interface ProductFormState {
	idProducts: number | null;
	productName: string;
	productCode: string;
	idCategories: number | null;
	idItems: number | null;
	idUnits: number | null;
	packing: string | number;
	size: number;
	weightInKg: number | null;
	lengthInFeet: number | null;
	productionCost: number;
	salePerUnit: number;
	remarks: string;
}

const initialState: ProductFormState = {
	idProducts: null,
	productName: '',
	productCode: '',
	idCategories: null,
	idItems: null,
	idUnits: null,
	packing: '',
	size: 0,
	weightInKg: null,
	lengthInFeet: null,
	productionCost: 0,
	salePerUnit: 0,
	remarks: '',
};

const ProductCreate: React.FC<ProductCreateProps> = ({ show, handleClose, id }) => {
	const [product, setProduct] = useState<ProductFormState>(initialState);
	const [projects, setProjects] = useState<any[]>([]);
	const [categories, setCategories] = useState<any[]>([]);
	const [items, setItems] = useState<any[]>([]);
	const [units, setUnits] = useState<any[]>([]);
	const [selectedProject, setSelectedProject] = useState<any>(null);
	const [selectedCategory, setSelectedCategory] = useState<any>(null);
	const [selectedItem, setSelectedItem] = useState<any>(null);
	const [selectedUnit, setSelectedUnit] = useState<any>(null);
	const [isSubmitDisable, setSubmitDisable] = useState(false);
	const [loading, setLoading] = useState(false);

	const isProjectThree = Number(selectedProject?.value) === 3;

	const loadCategoriesByProject = (projectId: number | string, categoryToSelect?: any) => {
		if (!projectId) {
			setCategories([]);
			return;
		}

		fetch(process.env.REACT_APP_API_URL + 'product-categories?idProjects=' + projectId, getRequestOptions())
			.then((resp) => resp.json())
			.then((resp) => {
				const options = resp.map((item: any) => ({
					label: item.category_name,
					value: item.id_product_categories,
				}));
				setCategories(options);
				if (categoryToSelect) {
					const current = options.find((opt: any) => Number(opt.value) === Number(categoryToSelect.value));
					setSelectedCategory(current || categoryToSelect);
				}
			})
			.catch((error) => console.log(error, 'Error fetching product categories'));
	};

	useEffect(() => {
		if (!show) {
			return;
		}

		fetch(process.env.REACT_APP_API_URL + 'projects', getRequestOptions())
			.then((resp) => resp.json())
			.then((resp) => {
				const options = resp.data.map((item: any) => ({
					label: item.project_name,
					value: item.id_projects,
				}));
				setProjects(options);
			})
			.catch((error) => console.log(error, 'Error fetching projects'));

		fetch(process.env.REACT_APP_API_URL + 'allItems', getRequestOptions())
			.then((resp) => resp.json())
			.then((resp) => {
				const options = resp.map((item: any) => ({
					label: item.item_name,
					value: item.id_items,
					item_name: item.item_name,
				}));
				setItems(options);
			})
			.catch((error) => console.log(error, 'Error fetching items'));

		fetch(process.env.REACT_APP_API_URL + 'allUnits', getRequestOptions())
			.then((resp) => resp.json())
			.then((resp) => {
				const options = resp.map((item: any) => ({
					label: item.unit_name,
					value: item.id_units,
					unit_name: item.unit_name,
				}));
				setUnits(options);
			})
			.catch((error) => console.log(error, 'Error fetching units'));
	}, [show]);

	useEffect(() => {
		if (!show) {
			return;
		}

		if (id === 0) {
			setProduct(initialState);
			setSelectedProject(null);
			setSelectedCategory(null);
			setSelectedItem(null);
			setSelectedUnit(null);
			setCategories([]);
			return;
		}

		fetch(process.env.REACT_APP_API_URL + 'products/edit/' + id, getRequestOptions())
			.then((resp) => resp.json())
			.then((resp) => {
				const data = resp.data;
				setProduct({
					idProducts: data.idProducts,
					productName: data.productName || '',
					productCode: data.productCode || '',
					idCategories: data.idCategories,
					idItems: data.idItems,
					idUnits: data.idUnits,
					packing: data.packing,
					size: data.size,
					weightInKg: data.weightInKg != null ? Number(data.weightInKg) : null,
					lengthInFeet: data.lengthInFeet != null ? Number(data.lengthInFeet) : null,
					productionCost: data.productionCost,
					salePerUnit: data.salePerUnit,
					remarks: data.remarks || '',
				});

				const projectOption = data.idProjects
					? { label: data.projectName, value: data.idProjects }
					: null;
				setSelectedProject(projectOption);

				const categoryOption = data.idCategories
					? { label: data.categoryName, value: data.idCategories }
					: null;

				if (projectOption) {
					loadCategoriesByProject(projectOption.value, categoryOption);
				}

				setSelectedItem(data.idItems ? { label: data.itemName, value: data.idItems, item_name: data.itemName } : null);
				setSelectedUnit(data.idUnits ? { label: data.unitName, value: data.idUnits, unit_name: data.unitName } : null);
			})
			.catch((error) => console.log(error, 'Error fetching product'));
	}, [id, show]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setProduct((prev) => ({
			...prev,
			[name]: name === 'packing' || name === 'productCode'
				? value
				: (name === 'weightInKg' || name === 'lengthInFeet')
					? (value === '' ? null : Number(value))
					: Number(value),
		}));
	};

	const handleProjectChange = (option: any) => {
		setSelectedProject(option);
		setSelectedCategory(null);
		setProduct((prev) => ({
			...prev,
			idCategories: null,
			...(Number(option?.value) !== 3 ? { weightInKg: null, lengthInFeet: null } : {}),
		}));
		loadCategoriesByProject(option?.value ?? '');
	};

	const handleCategoryChange = (option: any) => {
		setSelectedCategory(option);
		setProduct((prev) => ({ ...prev, idCategories: option?.value ?? null }));
	};

	const handleItemChange = (option: any) => {
		setSelectedItem(option);
		setProduct((prev) => ({
			...prev,
			idItems: option?.value ?? null,
			productName: option?.item_name ?? prev.productName,
		}));
	};

	const handleUnitChange = (option: any) => {
		setSelectedUnit(option);
		setProduct((prev) => ({ ...prev, idUnits: option?.value ?? null }));
	};

	const productSave = async (event: React.FormEvent) => {
		event.preventDefault();

		if (!selectedProject) {
			Swal.fire({ icon: 'warning', title: 'Validation', text: 'Please select a project.' });
			return;
		}
		if (!selectedCategory) {
			Swal.fire({ icon: 'warning', title: 'Validation', text: 'Please select a category.' });
			return;
		}
		if (!selectedItem) {
			Swal.fire({ icon: 'warning', title: 'Validation', text: 'Please select a product group.' });
			return;
		}
		if (!selectedUnit) {
			Swal.fire({ icon: 'warning', title: 'Validation', text: 'Please select a unit.' });
			return;
		}
		if (!product.productName.trim()) {
			Swal.fire({ icon: 'warning', title: 'Validation', text: 'Product name is required.' });
			return;
		}

		setSubmitDisable(true);
		setLoading(true);

		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: 'You want to ' + (id === 0 ? 'create' : 'update') + ' this product?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Submit it!',
		});

		if (!confirm.value) {
			setSubmitDisable(false);
			setLoading(false);
			return;
		}

		const payload: Record<string, any> = {
			productName: product.productName,
			productCode: product.productCode.trim() || null,
			idCategories: selectedCategory.value,
			idItems: selectedItem.value,
			idUnits: selectedUnit.value,
			packing: product.packing,
			size: product.size,
			productionCost: product.productionCost,
			salePerUnit: product.salePerUnit,
			remarks: product.remarks.trim() || null,
		};

		if (isProjectThree) {
			payload.weightInKg = product.weightInKg;
			payload.lengthInFeet = product.lengthInFeet;
		}

		try {
			const url = id === 0
				? `${process.env.REACT_APP_API_URL}products/single-store`
				: `${process.env.REACT_APP_API_URL}products/update/${id}`;
			const response = await fetch(url, postRequestOptions(payload));
			const respData = await response.json();

			if (respData.success === true) {
				Swal.fire({
					icon: 'success',
					title: 'Success',
					text: respData.successMessage || 'Product saved successfully.',
				});
				handleClose(true);
			} else {
				const errorsMessage = respData.errors
					? validationErrorMsg(respData.errors).join('<br>')
					: (respData.errorMessage || 'Could not save product.');
				Swal.fire({
					icon: 'error',
					title: 'Error',
					html: errorsMessage,
				});
			}
		} catch (error) {
			console.log(error, 'catch the hoop');
		} finally {
			setSubmitDisable(false);
			setLoading(false);
		}
	};

	return (
		<Modal show={show} onHide={() => handleClose(false)} size="lg">
			<form onSubmit={productSave}>
				<Modal.Header closeButton>
					<Modal.Title>{id === 0 ? 'Create Product' : 'Edit Product'}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group row mb-3">
						<label className="col-lg-3 col-form-label text-end">Project</label>
						<div className="col-lg-8">
							<Select
								value={selectedProject}
								onChange={handleProjectChange}
								options={projects}
								menuPosition="fixed"
								placeholder="Select Project"
							/>
						</div>
					</div>
					<div className="form-group row mb-3">
						<label className="col-lg-3 col-form-label text-end">Category</label>
						<div className="col-lg-8">
							<Select
								value={selectedCategory}
								onChange={handleCategoryChange}
								options={categories}
								menuPosition="fixed"
								placeholder={selectedProject ? 'Select Category' : 'Select a project first'}
								isDisabled={!selectedProject}
							/>
						</div>
					</div>
					<div className="form-group row mb-3">
						<label className="col-lg-3 col-form-label text-end">Product Group</label>
						<div className="col-lg-8">
							<Select
								value={selectedItem}
								onChange={handleItemChange}
								options={items}
								menuPosition="fixed"
								placeholder="Select Product Group"
							/>
						</div>
					</div>
					<div className="form-group row mb-3">
						<label className="col-lg-3 col-form-label text-end">Product Name</label>
						<div className="col-lg-8">
							<input
								type="text"
								name="productName"
								value={product.productName}
								onChange={(e) => setProduct((prev) => ({ ...prev, productName: e.target.value }))}
								className="form-control form-control-sm"
							/>
						</div>
					</div>
					<div className="form-group row mb-3">
						<label className="col-lg-3 col-form-label text-end">Product Code</label>
						<div className="col-lg-8">
							<input
								type="text"
								name="productCode"
								value={product.productCode}
								onChange={handleChange}
								className="form-control form-control-sm"
								placeholder="Optional"
							/>
						</div>
					</div>
					<div className="form-group row mb-3">
						<label className="col-lg-3 col-form-label text-end">Unit</label>
						<div className="col-lg-8">
							<Select
								value={selectedUnit}
								onChange={handleUnitChange}
								options={units}
								menuPosition="fixed"
								placeholder="Select Unit"
							/>
						</div>
					</div>
					<div className="form-group row mb-3">
						<label className="col-lg-3 col-form-label text-end">Packing</label>
						<div className="col-lg-8">
							<input type="text" name="packing" value={product.packing} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row mb-3">
						<label className="col-lg-3 col-form-label text-end">Size</label>
						<div className="col-lg-8">
							<input type="number" name="size" value={product.size} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					{isProjectThree && (
						<>
							<div className="form-group row mb-3">
								<label className="col-lg-3 col-form-label text-end">Weight (KG)</label>
								<div className="col-lg-8">
									<input
										type="number"
										step="0.001"
										name="weightInKg"
										value={product.weightInKg ?? ''}
										onChange={handleChange}
										className="form-control form-control-sm"
									/>
								</div>
							</div>
							<div className="form-group row mb-3">
								<label className="col-lg-3 col-form-label text-end">Length (Feet)</label>
								<div className="col-lg-8">
									<input
										type="number"
										step="0.001"
										name="lengthInFeet"
										value={product.lengthInFeet ?? ''}
										onChange={handleChange}
										className="form-control form-control-sm"
									/>
								</div>
							</div>
						</>
					)}
					<div className="form-group row mb-3">
						<label className="col-lg-3 col-form-label text-end">Production Cost</label>
						<div className="col-lg-8">
							<input type="number" name="productionCost" value={product.productionCost} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row mb-3">
						<label className="col-lg-3 col-form-label text-end">Sale Amount</label>
						<div className="col-lg-8">
							<input type="number" name="salePerUnit" value={product.salePerUnit} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row mb-3">
						<label htmlFor="remarks" className="col-lg-3 col-form-label text-end">Remarks</label>
						<div className="col-lg-8">
							<textarea
								name="remarks"
								id="remarks"
								value={product.remarks}
								onChange={(e) => setProduct((prev) => ({ ...prev, remarks: e.target.value }))}
								className="form-control form-control-sm"
								rows={3}
							/>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button type="submit" disabled={isSubmitDisable || loading} className="btn btn-sm btn-primary me-2">
						{loading && (
							<Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
						)}
						<span> Submit</span>
					</button>
					<Button variant="secondary" size="sm" onClick={() => handleClose(false)}>
						Close
					</Button>
				</Modal.Footer>
			</form>
		</Modal>
	);
};

export default ProductCreate;
